import React from 'react'
import { motion } from 'framer-motion'
import Services from '../components/Services'
import SEO from '../components/SEO'

const ServicesPage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for Services Page */}
      <SEO url="https://logicloud.mx/services" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Services />
      </motion.div>
    </>
  )
}

export default ServicesPage

